import FooterLink from '@/components/FooterLink/FooterLink';
import FacebookIcon from '@/components/Icons/FacebookIcon';
import InstagramIcon from '@/components/Icons/InstagramIcon';
import TwitterIcon from '@/components/Icons/TwitterIcon';
import { useAppContext } from '@/contexts/AppContext';
import type { FC } from 'react';

const SocialNetworkLinks: FC = () => {
  const { community } = useAppContext();

  if (!community.contactInformation) {
    return null;
  }

  return (
    <div className="flex space-x-4">
      {community.contactInformation.instagramURL ? (
        <FooterLink href={community.contactInformation.instagramURL} external label="Instagram">
          <InstagramIcon />
        </FooterLink>
      ) : null}

      {community.contactInformation.facebookURL ? (
        <FooterLink href={community.contactInformation.facebookURL} external label="Facebook">
          <FacebookIcon />
        </FooterLink>
      ) : null}

      {community.contactInformation.xURL ? (
        <FooterLink href={community.contactInformation.xURL} external label="X">
          <TwitterIcon />
        </FooterLink>
      ) : null}
    </div>
  );
};

export default SocialNetworkLinks;
